<template>
  <div :class="{'disease-button-wrapper': !isDisplay}">
    <div class="button-scroll button-scroll-left" @click="scrollToLeft" v-if="!isDisplay">
      <i class="fas fa-chevron-left"></i>
    </div>
    <div class="button-wrapper" id="wrapper">
      <disease-stamp
        v-for="(disease, index) in diseaseCode"
        :key="index"
        :index="disease"
        :diseaseName="disease"
        :onOff="disease === diseaseCodeIndex"
        @setDiseaseIndex="setDiseaseIndex"
      />
    </div>
    <div class="button-scroll button-scroll-right" @click="scrollToRight" v-if="!isDisplay">
      <i class="fas fa-chevron-right"></i>
    </div>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import _ from 'lodash'

import ButtonComponent from "../../atoms/Button";
import DiseaseStamp from "../../atoms/ReportDiscription/DiseaseStamp";

export default {
  data() {
    return {
      isDisplay: null,
    }
  },
  components: {
    ButtonComponent,
    DiseaseStamp
  },
  props: {
    diseaseCodeIndex: VueTypes.string.isRequired,
    diseaseCode: VueTypes.arrayOf(VueTypes.string.isRequired)
  },
  methods: {
    setDiseaseIndex(index) {
      this.$emit("setDiseaseCodeIndex", index);
    },
    scrollToRight() {
      let wrapper = this.$el.querySelector("#wrapper");
      wrapper.scrollLeft += 300;
    },
    scrollToLeft() {
      let wrapper = this.$el.querySelector("#wrapper");
      wrapper.scrollLeft -= 300;
    },
    handleResize() {
      let width = window.innerWidth
      if (width > 960) {
        this.isDisplay = true
      } else {
        this.isDisplay = false
      }
    },
  },
  mounted () {
    window.addEventListener('resize', _.debounce(this.handleResize), 500)
    if (window.innerWidth > 960) {
      this.isDisplay = true
    } else {
      this.isDisplay = false
    }
  },
  deforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
};
</script>

<style scoped>
.disease-button-wrapper {
  display: flex;
  justify-content: space-around;
}
.button-wrapper {
  display: flex;
  justify-content: space-around;
  overflow: hidden;
}
.fa-chevron-left,
.fa-chevron-right {
  font-size: 2rem;
}
.button-scroll {
  cursor: pointer;
  color: #d3d3d3;
}
.button-scroll-left {
    border-right: 2px solid #d3d3d3;
}
.button-scroll-right {
    border-left: 2px solid #d3d3d3;
}

</style>
